import { DriverScoreTooltipLabel, TooltipContent } from '../types/tooltip';

export const DRIVER_SCORE_TOOLTIP_CONTENT: Record<DriverScoreTooltipLabel, TooltipContent> = {
	smoothness: {
		title: 'Smoothness Rating',
		description:
			'This is based on measuring your acceleration, braking, deceleration, changes in direction and up and down movement over the course of each journey. The smoother you drive, the higher your smoothness score will be.',
		tips: [
			'Try and leave a safe braking distance between you and the car in front',
			'When coming to a stop, for example at traffic lights, brake early and gradually to avoid jolting to a halt',
			'Think ahead when you are driving - what hazards could be around the next corner?',
			'Wait for a sufficient gap in the traffic before pulling out from a turning to avoid harsh acceleration',
		],
	},
	speed: {
		title: 'Speed Rating',
		description:
			'This is based on measuring your speed against both the average speed and, the speed limit for the roads you drive on. Your speed score drops when you drive faster than the road’s average speed/limit and rises when you drive slower.',
		tips: [
			'Stay legal – be mindful of the speed limit. You’re putting yourself and others at risk when you drive with excess speed, and could get fined',
			'Think about what speed is safe for the driving conditions at the time. It isn’t always safe to drive to the limit on every stretch of every road on every day',
			'Be aware of those around you. If you are driving faster than the other traffic then you should probably slow down',
		],
	},
	usage: {
		title: 'Usage Rating',
		description: 'This reflects where and when you drive, how often you travel, and how long your journeys are.',
		tips: [
			'Where possible, avoid driving at night, as this time of day is associated with a higher likelihood of accidents.',
			'Excessively long journeys can be dangerous. Try and have a short break at least every two hours.',
			'Where you can, try and limit the number of short trips you take each day. Naturally, the more you drive, the chances of having an accident could increase.',
		],
	},
};
